import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { useTramaClient } from '../context.js';
import type { TramaProduct } from 'trama-types';
import type { FetchProductsOptions } from 'trama-types';

export function useProducts(options?: FetchProductsOptions) {
  const client = useTramaClient();

  return useQuery({
    queryKey: ['products', options],
    queryFn: () =>
      client.request<TramaProduct[]>('/api/v1/products', {
        params: {
          collectionId: options?.collectionId,
          limit: options?.limit,
          page: options?.page,
          sortBy: options?.sortBy,
        },
      }),
  });
}

export function useInfiniteProducts(options?: Omit<FetchProductsOptions, 'page'>) {
  const client = useTramaClient();

  return useInfiniteQuery({
    queryKey: ['products', 'infinite', options],
    queryFn: ({ pageParam = 1 }) =>
      client.request<TramaProduct[]>('/api/v1/products', {
        params: {
          collectionId: options?.collectionId,
          limit: options?.limit ?? 20,
          page: pageParam as number,
          sortBy: options?.sortBy,
        },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      (lastPage as TramaProduct[]).length === (options?.limit ?? 20) ? allPages.length + 1 : undefined,
  });
}
